import React, { StrictMode }     from 'react';
import ReactDOM                  from 'react-dom';
import { ApplicationInsights }   from '@microsoft/applicationinsights-web';
import { App }                   from './App';
import { store, browserHistory } from './store';

const { APP_INSIGHTS_KEY } = process.env;

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: APP_INSIGHTS_KEY,
  },
});

appInsights.loadAppInsights();
appInsights.trackPageView();

const renderRoot = (app: JSX.Element): void => {
  ReactDOM.render(app, document.getElementById('root'));
};

renderRoot(
  <StrictMode>
    <App store={store} history={browserHistory} />
  </StrictMode>,
);
